import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    Typography, TableContainer, TableRow,
    TableCell, Table, TableHead, TableBody
} from "@mui/material";
import SwitchComponent from "../../../components/Switch";
import TextFieldComponent from "../../../components/TextField";
import { ReactComponent as Search } from '../../../assets/Icons/search.svg';
import { getAssignedClientStaff, changeUserAssignedPage } from "../../../redux/UserAssignDuck";
import PaginationCustom from "../../../components/Pagination";
import './SecondStep.css';
import { useTranslation } from 'react-i18next';
import { getClientsName } from '../../../utils/functions'

const SecondStep = ({ setValues, notification, error }) => {
    const { t } = useTranslation(['notification', 'common']);
    const assignedClientStaff = useSelector(store => store.assign.assignedClientStaff);
    const activePageAssigned = useSelector(store => store.assign.activePageAssigned);
    const pagesAssigned = useSelector(store => store.assign.pagesAssigned);
    const [resetPageClientAssigned, setResetPageClientAssigned] = useState(false);
    const [searchAssigned, setSearchAssigned] = useState('');
    const dispatch = useDispatch();

    //componentDidMount
    useEffect(() => {
        dispatch(changeUserAssignedPage(1));
        //component will unmount
        return () => {
            dispatch(changeUserAssignedPage(1));
        }
    }, [dispatch]);

    const onSwitch = (id, event) => {
        const { checked } = event.target;
        const list = notification.receivers;
        if (!checked) {
            const receiver = list.find(d => String(d.id) === String(id));
            const index = list.indexOf(receiver);
            index > -1 && list.splice(index, 1);
        } else {
            const receiver = assignedClientStaff.find(d => String(d.id) === String(id));
            list.push(receiver);
        }
        setValues({ ...notification, receivers: list });
    };

    const onChangeSearchAssigned = (e) => {
        setSearchAssigned(e.target.value);
        setResetPageClientAssigned(true);
    };

    useEffect(() => {
        const page = resetPageClientAssigned ? 0 : activePageAssigned;
        const filterBy = [
            { search: '1', filterBy: 'status' }
        ];
        notification.clientId !== 'all' && filterBy.push({ search: String(notification.clientId), filterBy: 'client' });
        searchAssigned !== '' && filterBy.push({ search: searchAssigned, filterBy: 'search-bar' });

        const timer = setTimeout(() =>
            dispatch(getAssignedClientStaff(filterBy, page, 10, true)), 1000);
        setResetPageClientAssigned(false);
        return () => clearTimeout(timer);
        // eslint-disable-next-line
    }, [dispatch, searchAssigned]);

    useEffect(() => {
        const page = resetPageClientAssigned ? 0 : activePageAssigned;
        const filterBy = [
            { search: String(notification.clientId), filterBy: 'client' },
            { search: '1', filterBy: 'status' }
        ];
        searchAssigned !== '' && filterBy.push({ search: searchAssigned, filterBy: 'search-bar' });

        dispatch(getAssignedClientStaff(filterBy, page, 10, true));
        setResetPageClientAssigned(false);
        // eslint-disable-next-line
    }, [dispatch, activePageAssigned]);

    return (
        <div>
            <div className="container-app-div">
                <Typography className="app-form-title">{t("subtitle5")}</Typography>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ width: '35%' }}>
                        <TextFieldComponent Icon={<Search />}
                            position='start' placeholder={t("common:commonSearchPlh")}
                            valueInput={searchAssigned}
                            callback={onChangeSearchAssigned}
                        />
                    </div>
                </div>
                <TableContainer>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell className='table-app-title-header'>{t("headerTbl5")}</TableCell>
                                <TableCell className='table-app-title-header'>{t("headerTbl6")}</TableCell>
                                <TableCell className='table-app-title-header'>{t("headerTbl7")}</TableCell>
                                <TableCell className='table-app-title-header' align="right"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {assignedClientStaff.length === 0 &&
                                <TableRow key='empty'>
                                    <TableCell colSpan={4} style={{ textAlign: 'center' }}>
                                        {t("common:commonNoResultsLbl")}
                                    </TableCell>
                                </TableRow>
                            }
                            {assignedClientStaff.map(item => (
                                <TableRow key={item.id} className={
                                    !notification.receivers.find(r => String(r.id) === String(item.id))
                                    && 'dest-disabled'
                                }>
                                    <TableCell component="th" scope="row" className='notifications-text-active-clients'>
                                        {item.firstName} {item.lastName}
                                    </TableCell>
                                    <TableCell component="th" scope="row" className='notifications-text-active-clients'>
                                        {item.email}
                                    </TableCell>
                                    <TableCell component="th" scope="row" className='notifications-text-active-clients'>
                                        {item.clients ? getClientsName(item.clients) : ''}
                                    </TableCell>
                                    <TableCell align="right">
                                        <SwitchComponent
                                            callback={onSwitch.bind(this, item.id)}
                                            checked={!!notification.receivers.find(r => String(r.id) === String(item.id))}
                                            name='receivers'
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <br />
                <PaginationCustom pages={pagesAssigned} activePage={activePageAssigned}
                    onChange={page => dispatch(changeUserAssignedPage(page))} />
                {error.receivers &&
                    <p className='app-error-text'>{error.receivers}</p>
                }
            </div>
        </div>
    );
}

export default (SecondStep);